import {useState, useEffect, useRef, forwardRef, useContext} from "react";
import axios from "axios";
import Loader from "../Loader/Loader";
import {useLocation, useNavigate, useOutletContext} from "react-router-dom";

import "./Chart.scss";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {Bar} from "react-chartjs-2";
import {ReactTabulator} from "react-tabulator";
import DatePicker from "react-multi-date-picker";
import CustomeDatePicker from "../CustomeDatePicker";

import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ReactToPrint, {PrintContextConsumer} from "react-to-print";
import {SetPrintDataContext} from "../../Pages";
import {toast} from "react-toastify";
import tableCalc from "../../utils/tableCalc";
import alert from "bootstrap/js/src/alert";
import TabulatorTableOptions from "../../utils/TabulatorTableOptions";
import numeric from "../../utils/NumericFunction";
import Swal from "sweetalert2";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const ComponentToPrintChartPlz = forwardRef((props, ref) => {

  const {chart} = props;
//debugger
  return (<div ref={ref}>
    {chart?.config && <Bar
      data={chart["config"]["data"]}
      options={chart["config"]["options"]}
      style={{maxHeight: "40vh"}}
    />}
  </div>);
});
const ComponentToPrintGridDataTabulator = forwardRef((props, ref) => {

  const {chart} = props;

  return (
    <div ref={ref}>
      <ReactTabulator
        columns={chart.table.column}
        data={chart.table.data}
        options={{selectable: 1, height: "100%"}}
        // events={{ rowClick: rowClickHandler }}
      />
    </div>
  );
});


export default function Chart({id}) {

  const whichDashBoardIsShowing = localStorage.getItem("dashboardType");
  const navigateTo = useNavigate();
  let outletContext = useOutletContext();

//debugger
  id = id === undefined ? outletContext : id;

  useEffect(() => {
    //debugger
    if (whichDashBoardIsShowing === "undefined") {

      Swal.fire({
        title: "which Dashboard Is Showing",
        html: "<div class='small'>نوع گزارشات داشبورد مدیریتی است یا گزارشات معمولی روانحساب؟ این مورد در  localStorage  ذخیره نشده</div>",
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'آها باشه',
      })
      // اینجا حالت عادیه  ینی داشبورد معمولی روانحساب رو داریم
    } else if (whichDashBoardIsShowing === "2") {
      //debugger
      // if (id === "0") {
      //   navigateTo("/showDashboardSettings");
      // }
        //debugger
      if (id === "-1") {
        navigateTo("/defineDashboardSettings")
        return

      } else {
        navigateTo("/showDashboardSettings", {state: {id}});
      }
      // return 0;
    } else if (whichDashBoardIsShowing === "1") {
    }

  }, [])

  const refToComponentToPrintGridTabulator = useRef();
  const ref = useRef();
  // console.log(outletContext);

  // const [chartId, setChartId] = useState(id === undefined ? outletContext : id);
  const formDOM = useRef(null);
  const [chart, setchart] = useState();

  const setDataToUseInOtherComponent = useContext(SetPrintDataContext);

  useEffect(() => {
    // فقط در صورتی این کد اجرا بشه که داشبورد نوع اول باشه
    if (whichDashBoardIsShowing === "1") {
      setchart();

      if (id === "1" || id === "2") {
        axios({
          method: "GET",
          url: `${localStorage.getItem("apiUrl")}/mreport/`,
          params: {id: id, type: "full", filter: ""},
          headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
        }).then(({data}) => {
          if (id === "1") {
            data.type = "balance";
            setDataToUseInOtherComponent(data);
            navigateTo("/factorprint");

          } else if (id === "2") {
            data.type = "costAndBenefit";
            setDataToUseInOtherComponent(data);
            navigateTo("/factorprint");
          } else {
            throw new Error("something went wrong!!! Id is not 1 is Not 2 ");
          }

        });
      } else {
        axios({
          method: "GET",
          url: `${localStorage.getItem("apiUrl")}/mchart/`,
          params: {id: id},
          headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
        }).then((response) => {
          let data = response.data;
          //debugger;
// این کد ورودی رو میگیره و عدد های بک رو اینتیجر میکنه
//                 let keys=[]
//                 let temp="";
//                 let counter=0
//                 for (let key of data.table.data) {
//
//                     for ( var property in key ) {
//                         counter++
//                         if(counter===2){
//                             temp=property;
//                         }
//                     }
//                     key[temp]=parseInt(key[temp])
//                 }

          data?.table && tableCalc.addSeparator(data.table.column, data.table.priceFields)
          setchart(data);
          // //debugger
          console.log(data);
          // wannaShowDataGridTable(data);
        });
      }
    }


  }, [id, outletContext]);


  const sendNewData = (e) => {
    let startDateInput = "";
    let endDateInput = "";
    e.preventDefault();
    console.log(formDOM);

    let elements = formDOM.current.getElementsByTagName('input');

    for (let element of elements) {
      if (element.value === "") {
        toast.error("لطفا فیلد های تاریخ رو پر کنید.");
        return;
      }
      if (element.name === "startDate") {
        startDateInput = element.value;
        console.log("startDate");
      }
      if (element.name === "endDate") {
        console.log("endDate");
        endDateInput = element.value;
      }
    }

    let temp1 = startDateInput.replaceAll("/", "")
    let temp2 = endDateInput.replaceAll("/", "")
    if (numeric.p2e(temp1) > numeric.p2e(temp2)) {
      toast.error("تاریخ دوم نباید از تاریخ اولی بیشتر باشد.");
      return;
    }

    id = id === undefined ? outletContext : id;

    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/mchart/`,
      params: {id: id, startDate: `${startDateInput}`, endDate: `${endDateInput}`},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then(({data}) => {

      tableCalc.addSeparator(data.table.column, data.table.priceFields)
      setchart(data);
      console.log(data);
      // wannaShowDataGridTable(data);
    });

  }


  const ReactTabulatorRef = useRef();

  function ReactTabulatorRefHandlePrint() {
    if (ReactTabulatorRef.current === null) {
      toast.error("چیزی برای پرینت وجود ندارد.");
    } else {
      // //debugger
      ReactTabulatorRef.current.table.print(false, false);
    }
  }

  return <div
    style={{
      'width': '100%', margin: '0 auto', 'height': '88vh', 'overflow': 'scroll',
    }}
  >
    {

      chart === undefined ? (
        <>
          <Loader/>
        </>
      ) : (
        chart.type === 1 ? <>
            <h3 className={"text-center my-3"}>{chart.title}</h3>
            <div className={"my-4 d-flex justify-content-center text-center"}>
              <form ref={formDOM} className={"gx-4 my-0 text-center d-flex justify-content-start"}>
                <div className="mx-1">
                  <div className="form-control">
                    <CustomeDatePicker
                      // calendar={persian}
                      className="form-control"
                      placeholder="از تاریخ"
                      // locale={persian_fa}
                      calendarPosition="bottom-right"
                      name={"startDate"}
                    />
                  </div>
                </div>
                <div className="mx-1">
                  <div className="form-control col">
                    {/*<DatePicker*/}
                    {/*    calendar={persian}*/}
                    {/*    className="form-control"*/}
                    {/*    placeholder="تا تاریخ0"*/}
                    {/*    name={"endDate"}*/}
                    {/*    locale={persian_fa}*/}
                    {/*    calendarPosition="bottom-right"*/}
                    {/*/>*/}

                    <CustomeDatePicker
                      className="form-control"
                      placeholder="تا تاریخ"
                      calendarPosition="bottom-right"
                      name={"endDate"}
                    />


                  </div>
                </div>
                <div className="mx-1">
                  <button className={"btnCustom btnSubmit"} type="button" onClick={sendNewData}> نمایش</button>
                </div>
              </form>
            </div>
            <div className=" row justify-content-around">
              {chart?.showChart === 1 && <div className={" col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-center"}>
                <ComponentToPrintChartPlz ref={ref} chart={chart}/>
                {chart?.chartPrint &&
                  (<ReactToPrint content={() => ref.current}>
                    <PrintContextConsumer>
                      {({handlePrint}) => (
                        <button className={"btnCustom btnSubmit my-2"} onClick={handlePrint}> پرینت
                          چارت</button>
                      )}
                    </PrintContextConsumer>
                  </ReactToPrint>)}
              </div>}
              <div className={" col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 text-center"}></div>
              <div className={" col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 text-center"}>

                <ReactTabulator
                  ref={ReactTabulatorRef}
                  columns={chart.table.column}
                  data={chart.table.data}
                  // options={{selectable: 1, height: "100%"}}
                  options={TabulatorTableOptions.style1}
                  // events={{ rowClick: rowClickHandler }}
                />
                {chart?.gridePrint &&
                  <button className={"btnCustom btnSubmit my-2"}
                          onClick={ReactTabulatorRefHandlePrint}>پرینت جدول </button>
                }
              </div>
            </div>

          </> :
          <div className={"w-100 vh-85"}>
            <h3 className={"text-center my-2"}>{chart.title}</h3>
            <div className={"row mx-4"}>
              {chart?.showChart === 1 &&
                <div className={"col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11 text-center"}>
                  <ComponentToPrintChartPlz ref={ref} chart={chart}/>
                  {chart?.chartPrint &&
                    (<ReactToPrint content={() => ref.current}>
                      <PrintContextConsumer>
                        {({handlePrint}) => (
                          <button className={"btnCustom btnSubmit my-2"} onClick={handlePrint}> پرینت
                            چارت</button>
                        )}
                      </PrintContextConsumer>
                    </ReactToPrint>)}
                </div>}
              <div
                className={"col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11 text-center mt-3 d-flex justify-content-around"}>
                {/*    */}
                <div className={" text-center"} style={{"width": "80%"}}>
                  <ReactTabulator
                    ref={ReactTabulatorRef}
                    columns={chart?.table?.column || []}
                    data={chart?.table?.data|| []}
                    options={{selectable: 1, height: "100%"}}
                    // events={{ rowClick: rowClickHandler }}
                  />
                  {/**/}
                  {chart.gridePrint &&
                    <button className={"btnCustom btnSubmit my-2"}
                            onClick={ReactTabulatorRefHandlePrint}>پرینت
                      جدول </button>
                  }
                </div>
                {/*<div className={"col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"}></div>*/}
                <div className={"d-flex justify-content-center align-items-lg-start text-center "}>
                  <form ref={formDOM} className={"row  gx-2 mx-auto my-0"}
                        style={{"width": "270px"}}
                  >
                    <div className="col my-1 text-center">
                      <div className="form-control"
                      >
                        <CustomeDatePicker
                          className="form-control"
                          placeholder="از تاریخ"
                          name={"startDate"}
                          calendarPosition="bottom-right"
                        />
                      </div>
                    </div>
                    <div className="col my-1 text-center">
                      <div className="form-control"
                      >
                        <CustomeDatePicker
                          className="form-control"
                          placeholder="تا تاریخ"
                          name={"endDate"}
                          calendarPosition="bottom-right"
                        />
                      </div>
                    </div>
                    <div className="col-12 my-1 text-center">
                      <button className={"btnCustom btnSubmit"} type="button" onClick={sendNewData}> نمایش
                      </button>
                    </div>
                  </form>
                </div>

                {/*    */}
              </div>

            </div>


          </div>
      )
    }


  </div>
}
